import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MemberService } from '../services/member.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsResolver implements Resolve<any> {
  constructor(private memberService: MemberService) {}
  resolve(): Observable<any> {
    console.log('ProductsResolver: Resolving data...');
    return this.memberService.getMemberProducts().pipe(
      tap((data) => console.log('ProductsResolver: Data resolved:', data)),
      catchError((error) => {
        console.error('ProductsResolver: Error resolving data:', error);
        return throwError(error);
      })
    );
  }
}
